import { useAuth0 } from '../../auth';
import { config } from '../../config/environment';
import { AnonymousMenu } from './components/anonymous-menu/anonymous-menu';
import { AuthenticatedMenu } from './components/authenticated-menu/authenticated-menu';

export const AuthMenu = () => {
  const { isAuthenticated } = useAuth0();

  if (config.platformMode === 'archive') {
    return null;
  }
  return isAuthenticated ? <AuthenticatedMenu /> : <AnonymousMenu />;
};
